module.exports = new __parcel__URL__("VIT-Bhopal-Logo.5853daec.jpg").toString();